import { defPageSize } from "../../constants/events";
import { z } from "zod";

export const eventFiltersCacheKey = "EVENT_FILTERS_CACHE_KEY";

export interface EventListRequestParams {
  user_id?: number;
  customer_id?: number;
  group_id?: number;
  search_in_subgroup?: boolean;
  user_status_id?: number;
  date_create_min?: string;
  date_create_max?: string;
  date_complete_min?: string;
  date_complete_max?: string;
  status_ids?: number[];
  type_ids?: number[];
  order_param?: "date_start" | "date_end"
  order_dir?: "ASC" | "DESC" | "RELATIVE";
  offset?: number;
  limit?: number;
  search_query?: string;
}

export const EventListRequestParamsSchema = z.object({
  user_id: z.number().optional(),
  group_id: z.number().optional(),
  search_in_subgroup: z.boolean().optional(),
  customer_id: z.number().optional(),
  date_create_min: z.string().optional(),
  date_create_max: z.string().optional(),
  date_complete_min: z.string().optional(), // Новый параметр
  date_complete_max: z.string().optional(), // Новый параметр
  status_ids: z.array(z.number()).optional(),
  type_ids: z.array(z.number()).optional(),
  search_query: z.string().optional(),
  order_param: z.enum(["date_start", "date_end"]).optional().default("date_start"),
  order_dir: z.enum(["ASC", "DESC", "RELATIVE"]).optional().default("ASC"),
  offset: z.number().default(0),
  limit: z.number().default(defPageSize),
});

export const defaultEventFilters: EventListRequestParams = {
    status_ids: [1],
    order_param: "date_end",
    order_dir: "RELATIVE",
    limit: defPageSize,
    search_in_subgroup: true
}
